/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable import/no-unused-modules */

import React, {
  createContext,
  Dispatch,
  ReactElement,
  ReactNode,
  useContext,
  useState,
  useMemo,
} from 'react'
import { SectionType } from '../types/admin'

type AddTextAdminContextType = {
  addTextAdmin: SectionType[]
  setAddTextAdmin: Dispatch<SectionType[]>
}

const AddTextAdminContext = createContext<AddTextAdminContextType>({
  addTextAdmin: [],
  setAddTextAdmin: (): void => {
    throw new Error('AddTextAdminContext not initialized')
  },
})

interface IAddTextAdminProvider {
  children: ReactNode
}

export function AddTextAdminProvider({
  children,
}: IAddTextAdminProvider): ReactElement {
  const [addTextAdmin, setAddTextAdmin] = useState<SectionType[]>()

  const value = useMemo(
    () => ({ addTextAdmin: addTextAdmin || [], setAddTextAdmin }),
    [addTextAdmin, setAddTextAdmin]
  )

  return (
    <AddTextAdminContext.Provider value={value}>
      {children}
    </AddTextAdminContext.Provider>
  )
}

export const useAddTextAdminContext = (): AddTextAdminContextType =>
  useContext(AddTextAdminContext)
